// @ts-nocheck
import * as React from "react";
const { useEffect, useRef, useState } = React;

export function useScrollSpy(
  selectors: string[],
  options?: IntersectionObserverInit,
) {
  const [activeId, setActiveId] = useState<string>();
  const observer = useRef<IntersectionObserver>();
  useEffect(() => {
    const elements = selectors?.map((selector) =>
      document?.querySelector<Element>(selector),
    ) as Element[];
    if (observer?.current) {
      observer?.current?.disconnect();
    }
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry?.isIntersecting) {
          setActiveId(entry?.target?.getAttribute("id") as string);
        }
      });
    }, options);
    elements?.forEach((el) => el && observer?.current?.observe(el as Element));
    return () => observer?.current?.disconnect();
  }, [selectors]);

  return activeId;
}
